import script from "./BodorNest10.vue?vue&type=script&setup=true&lang=js"
export * from "./BodorNest10.vue?vue&type=script&setup=true&lang=js"

import "./BodorNest10.vue?vue&type=style&index=0&id=564a6b7e&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-564a6b7e"]])

export default __exports__